import React from "react";
function OngoingStudies() {
  const data = [
    {
      s_no: "1",
      title:
        "Farmer Perception Regarding Production and Marketing of Quality Seed in Madhya Pradesh",
      unit: "AERC, Jabalpur",
      study: "AER Centre, Jabalpur",
      state: "Madhya Pradesh",
      district_coverd: "3",
      name_of_dist:
        " Hoshangabad for Wheat, Dewas for Gram and Ujjain for Soybean",
      sample_size: "120",
    },
    {
      s_no: "2",
      title:
        "Estimating and Bridging the Yield Gaps in Soybean in Madhya Pradesh for Atam Nirbhar Bharat",
      unit: "AERC, Delhi",
      study: "AERC, Delhi",
      state: "Madhya Pradesh",
      district_coverd: "2",
      name_of_dist: "Ujjain, Rajgarh",
      sample_size: "180",
    },
    {
      s_no: "3",
      title:
        "Cost of Milk Production and Gross Returns to Milk Producers in Madhya Pradesh",
      unit: "AERC, ANAND Gujarat",
      study:
        "Dairy Division, DAHD, Ministry of Fishries, Animal Husbandary and Dairying",
      state: "Madhya Pradesh",
      district_coverd: "6",
      name_of_dist: "Alirajpur, Mandsour, Seopur, Katni, Chhatarpur and Mandla",
      sample_size: "300",
    },
    {
      s_no: "4",
      title:
        "Decentralized Procurement Scheme for Procurement of Wheat under Minimum Support Price(MSP) in Madhya Pradesh",
      unit: "IEG, New Delhi",
      study:
        "Department of Food and Public Distribution, Ministory of Consumer Affairs, Food and Public Distribution",
      state: "Madhya Pradesh",
      district_coverd: "2",
      name_of_dist: "	Hoshangabad and Vidisha",
      sample_size: "180",
    },
    {
      s_no: "5",
      title:
        "	Decentralized Procurement Scheme for Procurement of Paddy under Minimum Support Price(MSP) in Chhattisgarh",
      unit: "IEG, New Delhi",
      study:
        "Department of Food and Public Distribution, Ministory of Consumer Affairs, Food and Public Distribution",
      state: "Chhattisgarh",
      district_coverd: "2",
      name_of_dist: "Janjgir-Champa and Rajnandgaon",
      sample_size: "180",
    },
    {
      s_no: "6",
      title:
        "An Analysis of Factors Contributing to the Production and Productivity of Pulses in Madhya Pradesh- The study of Urd and Moong bean based on the successful experience of Myanmar.",
      unit: "IIM Ahemadabad Gujarat",
      study: "NFSM Cell, Crops & PHMF Division, DA&FW",
      state: "Madhya Pradesh",
      district_coverd: "1",
      name_of_dist: "Satna for Urd and Moong",
      sample_size: "200",
    },
    {
      s_no: "7",
      title: "Land Titling and Agricultural Productivity in Madhya Pradesh",
      unit: "ADRTC, ISEC Bengluru, Karnataka",
      study: "ADRTC, ISEC Bengluru, Karnataka",
      state: "Madhya Pradesh",
      district_coverd: "2",
      name_of_dist: "Ratlam and Damoh",
      sample_size: "240",
    },
    {
      s_no: "8",
      title:
        "Impact Evaluation of Pilot Project “Development of Model Villages under Soil Health Card Scheme’’ in Madhya Pradesh",
      unit: "ADRTC, ISEC Bengluru, Karnataka",
      study: "Fertilizer use Cell/INM Division, DA&FW",
      state: "Madhya Pradesh",
      district_coverd: "3",
      name_of_dist: "Ujjain, Rajgarh",
      sample_size: "180",
    },
    {
      s_no: "9",
      title:
        "Farmers Suicide: Causes and Policy Prescription in Madhya Pradesh",
      unit: "ADRTC, ISEC Bengluru, Karnataka",
      study: "Policy, Division, DA&FW",
      state: "Madhya Pradesh",
      district_coverd: "2",
      name_of_dist: "Rewa-Re-Survey Alirajpur-New Survey",
      sample_size: "120",
    },
    {
      s_no: "10",
      title: "Farmers Suicide: Causes and Policy Prescription in Chhattisgarh",
      unit: "ADRTC, ISEC Bengluru, Karnataka",
      study: "Policy, Division, DA&FW",
      state: "Chhattisgarh",
      district_coverd: "2",
      name_of_dist: "Surajpur-Re-Survey Bilashpur-New Survey",
      sample_size: "120",
    },
    {
      s_no: "11",
      title: "Consumption Pattern of Edible Oils in Madhya Pradesh",
      unit: "IEG, New Delhi",
      study: "Oilseeds Division, DA&FW",
      state: "Madhya Pradesh",
      district_coverd: "5",
      name_of_dist: "Jabalpur, Satna, Sheopur, Ratlam, Betul",
      sample_size: "500",
    },
    {
      s_no: "11",
      title: "Consumption Pattern of Edible Oils in Madhya Pradesh",
      unit: "IEG, New Delhi",
      study: "Oilseeds Division, DA&FW",
      state: "Madhya Pradesh",
      district_coverd: "5",
      name_of_dist: "Jabalpur, Satna, Sheopur, Ratlam, Betul",
      sample_size: "500",
    },
  ];
  const NewData = data.map((item, i) => (
    <tr key={i}>
      <td>{item.s_no}</td>
      <td>{item.title}</td>
      <td>{item.unit}</td>
      <td>{item.study}</td>
      <td>{item.state}</td>
      <td>{item.district_coverd}</td>
      <td>{item.name_of_dist}</td>
      <td>{item.sample_size}</td>
    </tr>
  ));
  return (
    <div>
      <section class="about section">
        <div class="container">
          <div class="row">
            <div class="about-content">
              <h3>On-going Studies</h3>
              <div class="ongoing_table">
                <table style={{ width: "100%" }}>
                  <tr>
                    <th>S. No.</th>
                    <th>Title of Research Studies</th>
                    <th>Coordinating Unit</th>
                    <th>Study Proposed by</th>
                    <th>State Covered</th>
                    <th>District Covered</th>
                    <th>Name of District Covered</th>
                    <th>Sample Size (Total Households Nos)</th>
                  </tr>
                  {NewData}

                  <tr>
                    <td colspan="5" style={{ textAlign: "center" }}>
                      {" "}
                      Total
                    </td>
                    <td style={{ textAlign: "center" }}>30</td>
                    <td></td>
                    <td style={{ textAlign: "center" }}>2500</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
export default OngoingStudies;
